import { can } from '../utils/rights';

export default {
  links() {
    return [
      {
        to: '/rfqs',
        src: '/img/rfqs.svg',
        label: this.$t('menu.rfqs'),
        hidden: async () => !(await can('rfq', 'read')),
      },
      {
        to: '/orders',
        src: '/img/orders.svg',
        label: this.$t('menu.orders'),
        hidden: async () => !(await can('order', 'read')),
      },
      {
        to: '/my_parts',
        src: '/img/myparts.svg',
        label: this.$t('menu.myParts'),
        hidden: async () => !(await can('rfq', 'read')),
      },
      {
        to: '/settings',
        src: '/img/settings.svg',
        label: this.$t('menu.settings'),
        hidden: async () => !(await can('settings', 'read')),
      },
      {
        to: '/engineering_tools',
        src: '/img/engineeringtools.svg',
        label: this.$t('menu.engineeringTools'),
        hidden: async () => !(await can('engineering_tools', 'read')),
      },
    ];
  },
};
